export default "__VITE_ASSET__70eb1d97__"